import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bingtu",
  "use": "icon-bingtu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-bingtu\">\r\n  <path d=\"M475.5 959.4c-221.2 0-401.2-180-401.2-401.2 0-220.1 179.1-400 399.2-401.1h0.2c8.4 0 16.4 3.3 22.3 9.2 6 6 9.3 14 9.3 22.5V509h338.8c16.9 0 30.8 13.3 31.6 30.2l0.3 5.6c0.3 4.5 0.6 9 0.6 13.5 0.1 221.1-179.9 401.1-401.1 401.1zM442 222.1C271.5 239 137.7 383.6 137.7 558.2c0 186.3 151.6 337.8 337.8 337.8 181.6 0 330.1-144 337.6-323.7H473.7c-17.5 0-31.7-14.2-31.7-31.7V222.1z\" />\r\n  <path d=\"M929.2 479.9H558.8c-17.5 0-31.7-14.2-31.7-31.7V96.4c0-17.5 14.2-31.7 31.7-31.7l1.8-0.1c214.3 0 390.2 167.9 400.3 382.2 0.4 8.6-2.8 17.1-8.7 23.4-6 6.2-14.3 9.7-23 9.7z m-338.8-63.3h304C872 262 746.1 142.9 590.4 129.3v287.3z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/bingtu.svg
// module id = aqlP
// module chunks = 54